// ── Adapter Supabase do IPipelineMembersRepository ────────────────
// I/O contra public.pipeline_members (+ join em profiles).

import { getSupabase } from '@infra/supabase/client';
import type {
  IPipelineMembersRepository,
  PipelineMemberEntry,
  ListPipelineMembersOpts,
  UpsertPipelineMemberParams,
} from '@modules/config';

const client = () => {
  const s = getSupabase();
  if (!s) throw new Error('Supabase não inicializado.');
  return s;
};

const SELECT_RICH = `
  id, workspace_id, pipeline_id, profile_id, role, ativo,
  profile:profiles!pipeline_members_profile_id_fkey (
    id, nome, initials, color, avatar_url, ativo
  )
`;

export class SupabasePipelineMembersRepository implements IPipelineMembersRepository {
  fetchPipelineMembers = async (
    pipelineId: string,
    opts: ListPipelineMembersOpts,
  ): Promise<PipelineMemberEntry[]> => {
    let q = client()
      .from('pipeline_members')
      .select(SELECT_RICH)
      .eq('pipeline_id', pipelineId);
    if (opts.role) q = q.eq('role', opts.role);
    if (opts.onlyActive !== false) q = q.eq('ativo', true);
    const { data, error } = await q;
    if (error) throw error;
    return (data || []) as unknown as PipelineMemberEntry[];
  };

  upsertPipelineMember = async ({
    workspaceId, pipelineId, profileId, role, ativo = true,
  }: UpsertPipelineMemberParams): Promise<PipelineMemberEntry> => {
    const { data, error } = await client()
      .from('pipeline_members')
      .upsert(
        {
          workspace_id: workspaceId,
          pipeline_id: pipelineId,
          profile_id: profileId,
          role,
          ativo,
        },
        { onConflict: 'pipeline_id,profile_id,role' },
      )
      .select(SELECT_RICH)
      .single();
    if (error) throw error;
    return data as unknown as PipelineMemberEntry;
  };

  setPipelineMemberActive = async (id: string, ativo: boolean): Promise<void> => {
    const { error } = await client()
      .from('pipeline_members')
      .update({ ativo: !!ativo })
      .eq('id', id);
    if (error) throw error;
  };

  deletePipelineMember = async (id: string): Promise<void> => {
    const { error } = await client().from('pipeline_members').delete().eq('id', id);
    if (error) throw error;
  };
}
